export type PastedNames = {
  names: string[];
  alreadyListed: number;
  repeated: number;
};

const LEADING_LIST_MARKER = /^(?:[•◦▪‣·*\-–—][ \t]|\d+[.)]\t)/;

function cleanLine(line: string): string {
  const withoutMarker = line.replace(LEADING_LIST_MARKER, "");
  const firstColumn = withoutMarker.split("\t")[0];
  return collapseWhitespace(firstColumn.replace(/ /g, " "));
}

function collapseWhitespace(value: string): string {
  return value.replace(/\s+/g, " ").trim();
}

function nameKey(name: string): string {
  return collapseWhitespace(name).toLowerCase();
}

export function parsePastedNames(text: string, existing: string[]): PastedNames {
  const seen = new Set(existing.map(nameKey));
  const listed = new Set(seen);
  const names: string[] = [];
  let alreadyListed = 0;
  let repeated = 0;

  for (const name of text.split(/\r\n|\r|\n/).map(cleanLine)) {
    if (!name) continue;
    const key = nameKey(name);
    if (listed.has(key)) {
      alreadyListed += 1;
      continue;
    }
    if (seen.has(key)) {
      repeated += 1;
      continue;
    }
    seen.add(key);
    names.push(name);
  }

  return { names, alreadyListed, repeated };
}
